module.exports = __webpack_public_path__ + "montserrat-light-webfont.2a1665c1326418518534.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/fonts/montserrat-light-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-light-webfont.woff2
// module chunks = main